import { useMemo } from "react";

export function useProfileCompletion(user) {
  const profileStatus = useMemo(() => {
    const fullName = user?.fullName?.trim();
    const phone = user?.phone?.trim();

    const hasFullName = !!fullName;
    const hasPhone = !!phone;

    const isComplete = hasFullName && hasPhone;

    return {
      isComplete,
      hasFullName,
      hasPhone,
      missingFields: [
        !hasFullName && "Full Name",
        !hasPhone && "Phone Number",
      ].filter(Boolean),
    };
  }, [user]);

  return profileStatus;
}